import {
    Box,
    Typography
} from '@mui/material'
import { DataAccordion } from '../../../../../../shared-components/DataAccordion'
import DashboardEmissionsTable from '../../../shared-components/DashboardEmissionsTable'
import { useDispatch, useSelector } from 'react-redux'
import { scopeOneEmissionColumns, scopeOneTitle } from '../../../constants/dashboard-constants'
import { useEffect } from 'react'
import { getCompanyEmissionsScopeOne } from '../../../../../../../actions/carbonfootprint-rework/07-emission-factors/01-emission-factors'


export default function ScopeOneEmissionsOverview({ openAccordion, changeAccordion, companyId, companyName, year }) {
    const dispatch = useDispatch()
    const accordionName = 'Scope One Emissions Overview'
    const columns = scopeOneEmissionColumns(companyName)
    const isLoading = useSelector((state) => (state.emissionFactorsReducer?.companyScopeOneLoading))
    const scopeOneEmissionRows = useSelector((state) => (state.emissionFactorsReducer?.companyEmissionsScopeOne.data))

    useEffect(() => {
        if (openAccordion === accordionName) {
            dispatch(getCompanyEmissionsScopeOne(companyId, year))
        }
    }, [dispatch,
        openAccordion,
        companyId,
        year])

    return (
        <DataAccordion
            title={scopeOneTitle}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: 2 }}>
                <Typography variant='h6'>
                    Scope One Emissions for {companyName} in {year}:
                </Typography>
                <DashboardEmissionsTable loading={isLoading} columns={columns} rows={scopeOneEmissionRows} />
            </Box>
        </DataAccordion>
    )
}